var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ArrowBack component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconArrowBack extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error',
            'cat-c-icon-bi-directional': true
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.5318 3.38531C12.8247 3.09242 12.8247 2.61754 12.5318 2.32465C12.2389 2.03176 11.764 2.03176 11.4711 2.32465L2.32612 11.4697C2.03322 11.7625 2.03322 12.2374 2.32612 12.5303L11.4711 21.6753C11.764 21.9682 12.2389 21.9682 12.5318 21.6753C12.8247 21.3824 12.8247 20.9075 12.5318 20.6147L4.66712 12.75H22.1429C22.5571 12.75 22.8929 12.4142 22.8929 12C22.8929 11.5858 22.5571 11.25 22.1429 11.25H4.66709L12.5318 3.38531Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconArrowBack.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowBack.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowBack.prototype, "size", void 0);
if (customElements.get('cat-icon-arrow-back') === undefined) {
    customElements.define('cat-icon-arrow-back', BlocksIconArrowBack);
}
